import {Button, Text} from "@mantine/core";
import { HomeRefinanceOptionsForm } from "features/homes/components/home.refinance-options/home.refinance-options.form";
import { useModals } from "@mantine/modals";
import {IRefinanceFormValues} from "features/homes/components/home.refinance-options/home.refinance-options.types";
import {useParams} from "react-router-dom";
import {homeHooks} from "features/homes/hooks";
import {EUserEventType} from "features/homes/types";

interface Props {
    onSubmitForm:(values:IRefinanceFormValues) => void,
}

export function HomeRefinanceOptionsButton({ onSubmitForm }:Props) {
    const modals = useModals();
    const {homeId} = useParams()
    const {mutateAsync: sendUserClickEvent} = homeHooks.useUserClickEvent()
    async function _onSubmitForm(values:any){
        await onSubmitForm(values);
        modals.closeAll();
    }

    const renderHomeForm = () => {
        sendUserClickEvent({eventType: EUserEventType.ViewedRefinanceOptions, homeId: parseInt(homeId!)})
        modals.openModal({
            withCloseButton:true,
            closeOnClickOutside:true,
            closeOnEscape:true,
            size:600,
            centered:true,
            overflow:'outside',
            title: (
                <Text size={'xl'}>Explore Refinance Options</Text>
            ),
            children: (
                <HomeRefinanceOptionsForm onSubmitQuery={_onSubmitForm}/>
            ),
        })
        return false;
    }

    return (
        <Button size="xs" variant="outline" onClick={renderHomeForm}>
            Explore Refinance Options
        </Button>
    )
}
